export default __webpack_public_path__ + "static/media/home_img_1.b5da392e.png";